import React from 'react';
import { Container, Heading, Divider, Box, Body, Link } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import { PRICING_FAQ, HELP_CENTER_LINK } from '../../../constants';
import { Accordion } from '../../ui';

const PricingFAQ: React.FC = () => (
  <Container
    centerContent
    mt={{ base: 700, tablet: 1000 }}
    maxW="100%"
    mb={1000}
  >
    <Heading
      size={{ base: 500, tablet: 600, desktop: 700 }}
      fontWeight={{ base: 700, desktop: 700 }}
      marginBottom={{ base: 700, desktop: 700 }}
      textAlign="center"
    >
      Frequently Asked Questions
    </Heading>
    <Box flexDir="column" alignItems="center" maxW="770px">
      <Heading
        size={{ base: 300, tablet: 500 }}
        isDisplay
        textAlign="center"
        maxW="770px"
      >
        Take a look at our full feature breakdown.
      </Heading>
      <Heading
        size={{ base: 300, tablet: 500 }}
        isDisplay
        textAlign="center"
        marginBottom={{ base: '80px', tablet: '80px' }}
        maxW="770px"
      >
        Still wonder which is best for your team? We’re here to help.
      </Heading>
    </Box>
    <Box flexDir="column" maxW="790px" mb="88px">
      <Divider
        borderColor="neutral.500"
        borderWidth="1px"
        borderTopWidth={0}
        my={0}
      />
      {PRICING_FAQ.map(faq => (
        <Accordion title={faq.title} content={faq.content} key={faq.id} />
      ))}
    </Box>
    <Body size={500} fontWeight={300}>
      Still have questions? Never hesitate to contact{' '}
      <Link
        as={GatsbyLink}
        to={`${process.env.GATSBY_V2_PREFIX}/contact`}
        fontWeight={600}
      >
        Support
      </Link>{' '}
      or visit our{' '}
      <Link as={GatsbyLink} fontWeight={600} to={HELP_CENTER_LINK}>
        Help Center
      </Link>
      .
    </Body>
  </Container>
);

export default PricingFAQ;
